'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const{DataSet:DataSet,Timeline:Timeline}=require('vis-timeline');
const Formatters=require('../../../../dist-es6/client/formatters');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const{ScheduleRowDirectiveController:ScheduleRowDirectiveController}=require('../../../../dist-es6/client/directives/scheduleRowDirective/scheduleRowDirective');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ForecastRowDirective=function(_BaseControllerBacked){_inherits(ForecastRowDirective,_BaseControllerBacked);function ForecastRowDirective(){_classCallCheck(this,ForecastRowDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(ForecastRowDirective,[{key:'template',get:function()
{return''}},{key:'objectBindings',get:function()

{return['forecast','alertRanges','currentTime']}},{key:'$inject',get:function()

{return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}},{key:'controller',get:function()

{return ForecastRowController}}]);return ForecastRowDirective}(BaseControllerBackedDirective);let


ForecastRowController=function(_ScheduleRowDirective){_inherits(ForecastRowController,_ScheduleRowDirective);
function ForecastRowController($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){_classCallCheck(this,ForecastRowController);return _possibleConstructorReturn(this,
_ScheduleRowDirective.call(this,$scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService));
}ForecastRowController.prototype.

_updateData=function _updateData(){
let newData=[];

const currentTime={
id:'current-time',
start:this.currentTime,
type:'point',
className:'current-time'};


const pastMask={
id:'past-mask',
start:this.currentBounds.start,
end:this.currentTime,
type:'range',
className:'past-mask'};


if(this.forecast&&this.alertRanges){
let expectedScenarioBounds;
if(_.exists(this.forecast.scenario)&&this.forecast.scenario.duties&&this.forecast.scenario.duties.length!==0){
newData.push({
id:'forecasted-duty',
start:this.forecast.scenario.duties[0].start,
end:this.forecast.scenario.duties[0].end,
className:`forecasted-duty`});

}

newData=newData.concat(
_getNamedRangesFrom(this.alertRanges.At,'at-threshold',_.noop),
_getNamedRangesFrom(this.alertRanges.Above,'above-threshold',_.noop),
_getNamedRangesFrom(this.forecast.schedule.trips,'trip',_formatTripLabel),
_getNamedRangesFrom(this.forecast.scenario.sleep,'sleep'),
_getNamedRangesFrom(this.forecast.schedule.duties,'duty'));


}

newData=_.compact([].concat(_toConsumableArray(newData),[pastMask,currentTime]));

const idsToRemove=_.without.apply(_,[this._dataset.getIds()].concat(_toConsumableArray(newData.map(function(d){return newData.id}))));
if(idsToRemove.length!==0){
this._dataset.remove(idsToRemove);
}

this._dataset.update(newData);
};_createClass(ForecastRowController,[{key:'currentBounds',get:function()

{
return this._scheduleRowScrollingService.axisBounds;
}}],[{key:'DefaultTimelineOptions',get:function()

{
return _timelineOptions;
}}]);return ForecastRowController}(ScheduleRowDirectiveController);


function _getNamedRangesFrom(data,name){let titleFormatter=arguments.length>2&&arguments[2]!==void 0?arguments[2]:_formatBasicInterval;
if(!data){
return[];
}

return data.map(function(d,i){return{
id:`${name}-${i}`,
start:d.start,
end:d.end,
title:titleFormatter(d),
className:name}});

}

function _formatTime(trip,key){
return Formatters.
formatInLocale(trip[key],`${Formatters.TwentyFourHourFormat} (Z)`,trip[key+'Timezone']).
replace(':00)',')');
}

function _formatBasicInterval(interval){
return`${_formatTime(interval,'start')} - ${_formatTime(interval,'end')}`;
}

function _formatTripLabel(trip){
return`${trip.origin.description} to ${trip.destination.description}<br/>${_formatTime(trip,'start')} - ${_formatTime(trip,'end')}`;
}

module.exports=ForecastRowDirective;
//# sourceMappingURL=forecastRowDirective.js.map
